/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import CustomFileInput from "../../../components/common/CustomFileInput";
import { Controller, FieldErrors, UseFormRegister } from "react-hook-form";
import FileUploader from "../../../components/common/FileUploader";
import { useEffect, useState } from "react";
import {
  useDistrictFetchData,
  useFetchCountriesAllData,
  useFetchCountryCitiesAllData,
  useFetchCountryWarehouseAllData,
} from "../../../apis/locationApis";
import Input from "../../../components/Input";
import SelectInput from "../../../components/Select";
import { useFetchStaffsAllData } from "../../../apis/staffApis";
import { useFetchVehicleAllData } from "../../../apis/vehicleApis";
import { getFileExtension } from "../../../utilities/helper";
import NewinputField from "../../../components/NewInput";
import NewSelectInput from "../../../components/NewSelectInput";
import NewCustomFileInput from "../../../components/common/NewCustomFileInput";
import {
  IconCloudUpload,
  IconId,
  IconPhoto,
  IconTrash,
  IconTruck,
  IconUser,
} from "@tabler/icons-react";
import ToggleButton from "../../../components/ToggleButton";
import { useFetchDriverTimeSlotAllData } from "../../../apis/timeSlotApis";
import { useSelector } from "react-redux";
import { useFetchDarkStoreAllData } from "../../../apis/darkStoreApi";
import { useFetchOutSourcesData } from "../../../apis/outSourceApis";
import { T } from "../../../context/LanguageContext";

export const SystemTypes = [
  { value: "phone", text: "Phone" },
  { value: "email", text: "Email" },
  { value: "whatsapp", text: "WhatsApp" },
];

const vehicleTypes = [
  { id: 1, value: "car", text: "Car" },
  { id: 2, value: "van", text: "Van" },
  { id: 3, value: "dokker", text: "Dokker" },
];
const driverTypes = [
  { id: 1, value: "COURIER", text: "Courier" },
  { id: 2, value: "FM", text: "FM" },
  { id: 3, value: "BOTH", text: "Both" },
  { id: 4, value: "DARK_STORE", text: "Dark Store" },
  { id: 5, value: "OUTSOURCE", text: "Outsource" },
  { id: 6, value: "IN_HOUSE", text: "In House" },
];

type FormValues = {
  name: string;
  mobileNo: string;
  email: string;
  licenseNumber: string;
  licenseExpiry: string;
  countryId: string;
  cityId: string;
  image: string;
  document: string;
  status?: string;
  districtId: string;
  warehouseId: string;
  address?: string;
  supervisorId?: string;
  startDate?: string;
  iqamaNumber?: string;
  iqamaDoc?: File | undefined;
  vehicleId?: string;
  driverType?: string;
  driverCode?: string;
  darkStoreId?: string;
  password?: string;
  outsourceId?: string;
};

type Props = {
  register: UseFormRegister<FormValues>;
  errors: FieldErrors<FormValues>;
  clearErrors?: any;
  setValue?: any;
  getIds?: any;
  watch?: any;
  control?: any;
  driverData?: any;
  setSelectedDocument?: any;
};

const getFileNameFromUrl = (url: string): string => {
  return decodeURIComponent(url?.split("/")?.pop()?.split("?")[0] || "");
};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      <T>{title}</T>
    </p>
  </div>
);

const AddDriverModal = ({
  register,
  errors,
  clearErrors,
  setValue,
  getIds,
  watch,
  control,
  driverData,
  setSelectedDocument,
}: Props) => {
  const [selectedSupervisor, setSelectedSupervisor] = useState<any>(
    watch("supervisorId") || "",
  );
  const [selectedTimeSlot, setSelectedTimeSlot] = useState<any>(
    watch("timeSlotId") || "",
  );
  const [assignVehicle, setAssignVehicle] = useState<any>(
    watch("vehicleId") || "",
  );
  const [warehouse, setWarehouse] = useState<any>(watch("warehouseId") || "");
  const { data: warehouses } = useFetchCountryWarehouseAllData();
  const { data: darkStores } = useFetchDarkStoreAllData();
  const { data } = useFetchCountriesAllData();
  const { data: timeSlotData, refetch: fetchTimeSlot } =
    useFetchDriverTimeSlotAllData();
  const { data: staffData } = useFetchStaffsAllData();
  const { data: vehicles } = useFetchVehicleAllData();
  const { data: outSourcesList } = useFetchOutSourcesData(1, 100, "");
  // const profile = useSelector((state: any) => state.auth.profile);

  useEffect(() => {
    if (driverData) {
      setValue("name", driverData?.driverName);
      setValue("mobileNo", driverData?.mobile_no);
      setValue("email", driverData?.email);
      setValue("warehouseId", driverData?.warehouseId);
      if (profile?.clientType === "DS") {
        setValue("countryId", driverData?.country_id);
        setValue("darkStoreId", driverData?.dark_store_id);
        setCreateLocation((prev: any) => ({
          ...prev,
          country: {
            id: driverData?.country_id,
            name: driverData?.country,
          },
          city: {
            id: driverData?.cityId,
            name: driverData?.city,
          },
          district: {
            id: driverData?.districtId,
            name: driverData?.district,
          },
        }));
      }
      setValue("cityId", driverData?.cityId);
      setValue("districtId", driverData?.districtId);
      setValue("address", driverData?.address);
      setValue("startDate", driverData?.start_date?.split("T")?.[0]);
      setValue("supervisorId", driverData?.supervisor_id);
      setValue("timeSlotId", driverData?.timeSlotId);
      setValue("vehicleType", driverData?.vehicle_type);
      setValue("vehicleId", driverData?.vehicle_id);
      setValue("iqamaNumber", driverData?.iqama_number);
      setValue("licenseNumber", driverData?.license_number);
      setValue("licenseDoc", driverData?.license_doc);
      setValue("iqamaDoc", driverData?.iqama_doc);
      setValue("image", driverData?.image);
      setValue("driverType", driverData?.driver_type);
      if (driverData?.driver_type === "OUTSOURCE") {
        SetToggle(true);
      }
      setValue("driverCode", driverData?.driver_code);
      if (driverData?.outsource_id)
        setValue("outsourceId", driverData?.outsource_id);
    }
  }, [driverData]);

  const [toggle, SetToggle] = useState(false);
  const [createLocation, setCreateLocation] = useState<any>({});
  const { data: countries = [] } = useFetchCountriesAllData();

  const {
    data: cities = [],
    refetch: fetchReceiverCities,
    isFetching: isFetchingCities,
  } = useFetchCountryCitiesAllData(createLocation?.country?.id);

  const {
    data: districts = [],
    refetch: fetchReceiverDistricts,
    isFetching: isFetchingDistricts,
  } = useDistrictFetchData(createLocation?.city?.id);

  useEffect(() => {
    if (createLocation?.country?.id) {
      fetchReceiverCities();
    }
  }, [createLocation?.country?.id]);

  useEffect(() => {
    if (createLocation?.city?.id) {
      fetchReceiverDistricts();
    }
  }, [createLocation?.city?.id]);
  // Only admin can edit the password of driver
  const profile = useSelector((state: any) => state.auth.profile);
  const isClient = profile?.type === "client";

  return (
    <div className="w-full space-y-4">
      <div className=" h-[calc(100vh-10rem)] overflow-y-auto space-y-4   p-4 scrollbar-clean">
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <div className="flex items-center justify-between">
            <SectionHeader icon={IconUser} title="Personal Details" />
            <div className="flex items-center gap-2 bg-[#FBD037]/10 px-3 py-1 rounded-full border border-[#FBD037]/20">
              <span className="text-xs font-semibold text-[#212121]">
                <T>As Outsource</T>
              </span>
              <ToggleButton
                onChange={() => {
                  const nextState = !toggle;
                  SetToggle(nextState);
                  if (nextState) {
                    setValue("driverType", "OUTSOURCE", {
                      shouldValidate: true,
                    });
                    clearErrors("driverType");
                  } else {
                    setValue("driverType", "", { shouldValidate: true });
                    setValue("outsourceId", undefined as any);
                  }
                }}
                checked={toggle}
              />
            </div>
          </div>

          <Controller
            control={control}
            name="image"
            rules={{
              validate: (file: File | string | undefined) => {
                if (!file || typeof file === "string") return true;
                if (file.size > 1 * 1024 * 1024)
                  return "File size must be 1 MB or less";
                const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
                const fileObj = file instanceof File ? file : null;
                if (fileObj && !allowedTypes.includes(fileObj.type)) {
                  if (
                    !["jpeg", "png", "jpg"].includes(getFileExtension(fileObj))
                  )
                    return "Only JPG, JPEG, or PNG allowed";
                }
                return true;
              },
            }}
            render={({ field, fieldState }) => {
              const fileURL =
                field.value instanceof File
                  ? URL.createObjectURL(field.value)
                  : typeof field.value === "string" && field.value !== ""
                    ? field.value
                    : "/img/dummy-logo.png";

              return (
                <div className="flex items-center gap-5 p-3 bg-gray-50/50 rounded-xl border border-dashed border-gray-200">
                  <div className="relative group">
                    <img
                      src={fileURL}
                      alt="Staff Profile"
                      className="w-20 h-20 rounded-xl object-cover border-2 border-[#FBD037]/50 shadow-md transition-all group-hover:scale-105"
                    />
                    <div className="absolute -bottom-1 -right-1 bg-[#FBD037] rounded-full p-0.5">
                      <IconPhoto size={14} className="text-white" />
                    </div>
                  </div>

                  <div className="space-y-1.5 flex-1">
                    <div className="flex items-center gap-3">
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png"
                        className="hidden"
                        id="imageUpload"
                        onChange={(e) => {
                          const file = e.target.files?.[0];
                          if (file) {
                            field.onChange(file);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              image: true,
                            }));
                            clearErrors("image");
                          }
                        }}
                      />
                      <label
                        htmlFor="imageUpload"
                        className="inline-flex items-center gap-2 text-[#212121] cursor-pointer border rounded-lg text-sm px-4 py-1.5 border-[#FBD037] bg-[#FBD037]/20 hover:bg-[#FBD037]/30 transition-all duration-200 font-medium"
                      >
                        <IconCloudUpload size={16} stroke={1.5} />
                        <T>Upload Logo</T>
                      </label>

                      {field.value && (
                        <button
                          type="button"
                          className="inline-flex items-center gap-1 text-red-500 text-sm hover:underline transition"
                          onClick={() => {
                            field.onChange(undefined);
                            setSelectedDocument?.((prev: any) => ({
                              ...prev,
                              image: false,
                            }));
                          }}
                        >
                          <IconTrash size={14} />
                          <T>Remove</T>
                        </button>
                      )}
                    </div>

                    <p className="text-xs text-gray-400">
                      <T>Accepted formats: PNG, JPG (Max file size: 1 MB)</T>
                    </p>

                    {fieldState.error && (
                      <p className="text-red-500 text-xs font-medium mt-1 flex items-center gap-1">
                        <span className="text-red-400">⚠</span>{" "}
                        <T>{fieldState.error.message}</T>
                      </p>
                    )}
                  </div>
                </div>
              );
            }}
          />
          <div className="grid grid-cols-2 gap-4">
            <NewinputField
              className="col-span-2"
              labelClass="w-full"
              name="name"
              type="text"
              title="Name"
              placeholder=""
              register={register}
              error={errors?.name}
              validation={{
                required: "Name is required",
                validate: (value: string) => {
                  const trimmed = value.trim();
                  if (trimmed.length < 3)
                    return "Name must be at least 3 characters";
                  if (trimmed.length > 30)
                    return "Name must be at most 30 characters";
                  if (!value?.trim())
                    return "Name cannot be empty or only spaces";
                  if (!/^[A-Za-z\u0600-\u06FF]/.test(trimmed)) {
                    return "Name must start from a letter";
                  }
                  return true;
                },
                pattern: {
                  value: /^[A-Za-z\u0600-\u06FF][A-Za-z\u0600-\u06FF0-9\s-]*$/,
                  message:
                    "Name must start from a letter (not from numbers)",
                },
              }}
            />
            <NewinputField
              className=""
              labelClass="w-full"
              name="mobileNo"
              type="text"
              title="Mobile Number"
              register={register}
              error={errors?.mobileNo}
              validation={{
                required: "Mobile number is required",
                validate: (value: string) => {
                  if (!/^\d+$/.test(value)) return "Only digits are allowed";

                  if (value.length !== 10) {
                    return "Mobile number must be exactly 10 digits";
                  }

                  if (/^0+$/.test(value)) {
                    return "Mobile number cannot be all zeros";
                  }

                  return true;
                },
              }}
              other={{
                onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                  let value = e.target.value.replace(/\D/g, "");
                  if (value.length > 10) {
                    value = value.slice(0, 10);
                  }
                  setValue("mobileNo", value, {
                    shouldValidate: true,
                    shouldDirty: true,
                  });
                },
              }}
            />

            <NewinputField
              className=""
              labelClass="w-full"
              name="email"
              type="text"
              title="Email"
              placeholder=""
              register={register}
              error={errors?.email}
              validation={{
                required: "Email is required",
                setValueAs: (value: string) => value?.toLowerCase(),
                pattern: {
                  value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                  message: "Please enter a valid email address",
                },
              }}
            />
            {driverData && isClient && (
              <NewinputField
                className="col-span-2"
                labelClass="w-full"
                name="password"
                type="password"
                title="New Password"
                placeholder="Leave blank to keep ..."
                register={register}
                error={errors?.password}
                validation={{
                  required: false,
                  minLength: {
                    value: 8,
                    message: "Password must be at least 8 characters",
                  },
                  maxLength: {
                    value: 16,
                    message: "Password must not exceed 16 characters",
                  },
                  validate: (value: string) => {
                    if (!value) return true;
                    if (!/[A-Z]/.test(value))
                      return "Must contain at least one uppercase letter";
                    if (!/[a-z]/.test(value))
                      return "Must contain at least one lowercase letter";
                    if (!/[0-9]/.test(value))
                      return "Must contain at least one number";
                    if (!/[!@#$%^&*(),.?/":{}|<>]/.test(value))
                      return "Must contain at least one special character";
                    return true;
                  },
                }}
              />
            )}
          </div>
        </div>
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconUser} title="employment Details" />
          <div className="grid grid-cols-3 gap-4">
            <NewSelectInput
              name="driverType"
              label="Driver Type"
              labelClass="w-full"
              placeholder=""
              selectOptions={driverTypes}
              register={register}
              validation={{ required: "Driver type is required" }}
              value={watch("driverType")?.toUpperCase()}
              disabled={toggle}
              setValue={(val: string) => {
                setValue("driverType", val, { shouldValidate: true });
                if (val === "OUTSOURCE") {
                  SetToggle(true);
                } else {
                  SetToggle(false);
                  setValue("outsourceId", undefined as any);
                }
              }}
            />

            {watch("driverType")?.toUpperCase() === "OUTSOURCE" && (
              <NewSelectInput
                labelClass="w-full"
                name="outsourceId"
                label="Outsource Company"
                placeholder=""
                selectOptions={
                  outSourcesList?.outSources?.map((os: any) => ({
                    id: os.id,
                    value: os.id,
                    text: os.companyName,
                  })) || []
                }
                clearErrors={clearErrors}
                register={register}
                validation={{ required: "Outsource Company is required" }}
                error={errors.outsourceId as any}
                disabled={
                  !outSourcesList?.outSources ||
                  outSourcesList?.outSources.length === 0
                }
                value={watch("outsourceId")}
                setValue={(val: string) => {
                  setValue("outsourceId", val);
                }}
              />
            )}

            {profile?.clientType === "DS" && (
              <NewSelectInput
                labelClass="w-full"
                name="darkStoreId"
                label="Dark Store"
                placeholder=""
                selectOptions={
                  darkStores?.map((darkStore: any) => ({
                    id: darkStore?.id,
                    value: darkStore?.id,
                    text: darkStore?.name,
                  })) || []
                }
                clearErrors={clearErrors}
                register={register}
                validation={{ required: "Dark Store is required" }}
                error={errors.darkStoreId}
                disabled={!darkStores || darkStores?.length === 0}
                value={watch("darkStoreId")}
                setValue={(val: string) => {
                  // setSelectedSupervisor(val);
                  setValue("darkStoreId", val);
                }}
              />
            )}

            <NewinputField
              name="driverCode"
              type="text"
              title="Driver Code"
              labelClass="w-full"
              placeholder=""
              register={register}
              error={errors?.driverCode}
              validation={{
                required: "Driver code is required",
                validate: (value: string) => {
                  const trimmed = value.trim();

                  if (trimmed.length < 3)
                    return "Driver code must be at least 3 characters";

                  // Only allow letters & numbers
                  if (!/^[A-Za-z0-9]+$/.test(trimmed))
                    return "Driver code must be alphanumeric without spaces";

                  // ❌ Block only-numbers like 12345
                  if (/^\d+$/.test(trimmed))
                    return "Driver code cannot be only numbers";

                  return true;
                },
              }}
            />

            {profile?.clientType !== "DS" ? (
              <>
                <NewSelectInput
                  name="warehouseId"
                  label="Warehouse"
                  labelClass="w-full"
                  placeholder=""
                  selectOptions={
                    warehouses?.warehouses?.map((warehouse: any) => ({
                      id: warehouse?.id,
                      value: warehouse?.id,
                      text: warehouse?.name,
                    })) || []
                  }
                  register={register}
                  clearErrors={clearErrors}
                  validation={{ required: "Warehouse is required" }}
                  error={errors.warehouseId}
                  disabled={!data || data.length === 0}
                  value={watch("warehouseId")}
                  setValue={(val: string) => {
                    setWarehouse(val);
                    const warehouse = warehouses?.warehouses?.find(
                      (c: any) => c.id === val,
                    );
                    setValue("warehouseId", val);
                    setValue("address", warehouse?.location);
                    setValue("cityId", warehouse?.city);
                    setValue("districtId", warehouse?.district);
                  }}
                />

                <NewinputField
                  name="cityId"
                  type="text"
                  title="City"
                  labelClass="w-full"
                  placeholder=""
                  register={register}
                  error={errors.cityId}
                  validation={{ required: "City is required" }}
                  disabled={true}
                  value={
                    warehouses?.warehouses?.find(
                      (e: any) => e?.id === watch("warehouseId"),
                    )?.cityName
                  }
                />

                <NewinputField
                  name="districtId"
                  type="text"
                  title="District"
                  labelClass="w-full"
                  placeholder=""
                  register={register}
                  error={errors.districtId}
                  validation={{ required: "District is required" }}
                  disabled={true}
                  value={
                    warehouses?.warehouses?.find(
                      (e: any) => e?.id === watch("warehouseId"),
                    )?.districtName
                  }
                />
              </>
            ) : (
              <>
                <NewSelectInput
                  name="countryId"
                  labelClass="w-full"
                  label="Country"
                  placeholder="Select Country"
                  selectOptions={countries.map((country: any) => ({
                    id: country.id,
                    value: country.id,
                    text: country.name,
                  }))}
                  register={register}
                  clearErrors={clearErrors}
                  error={errors.countryId}
                  validation={{ required: "country is required" }}
                  value={watch("countryId")}
                  setValue={(value: any) => {
                    setCreateLocation((prev: any) => ({
                      ...prev,
                      country: {
                        id: value,
                        name: countries?.find((c: any) => c.id === value)?.name,
                      },
                      city: undefined,
                      district: undefined,
                    }));
                    clearErrors("countryId");
                    setValue("countryId", value);
                  }}
                />
                <NewSelectInput
                  name="cityId"
                  labelClass="w-full"
                  label="City"
                  placeholder={
                    isFetchingCities ? "Loading cities..." : "Select City"
                  }
                  selectOptions={cities.map((city: any) => ({
                    id: city.id,
                    value: city.id,
                    text: city.name,
                  }))}
                  register={register}
                  clearErrors={clearErrors}
                  validation={{ required: "city is required" }}
                  error={errors.cityId}
                  value={watch("cityId")}
                  setValue={(value: any) => {
                    setCreateLocation((prev: any) => ({
                      ...prev,
                      city: {
                        id: value,
                        name: cities.find((c: any) => c.id === value)?.name,
                      },
                      district: undefined,
                    }));
                    clearErrors("cityId");
                    setValue("cityId", value);
                  }}
                />
                <NewSelectInput
                  name="districtId"
                  labelClass="w-full"
                  label="District"
                  placeholder={
                    isFetchingDistricts
                      ? "Loading districts..."
                      : "Select District"
                  }
                  selectOptions={
                    districts.map((district: any) => ({
                      id: district.id,
                      value: district.id,
                      text: district.name,
                    })) || []
                  }
                  register={register}
                  clearErrors={clearErrors}
                  error={errors.districtId}
                  validation={{ required: "district is required" }}
                  value={watch("districtId")}
                  setValue={(value: any) => {
                    setCreateLocation((prev: any) => ({
                      ...prev,
                      district: {
                        id: value,
                        name: districts.find((d: any) => d.id === value)?.name,
                      },
                    }));
                    clearErrors("districtId");
                    setValue("districtId", value);
                  }}
                />
              </>
            )}

            <NewinputField
              name="address"
              type="text"
              title="Address"
              labelClass="w-full"
              placeholder=""
              register={register}
              disabled={profile?.clientType !== "DS" ? true : false}
              error={errors.address}
              validation={{ required: "Address is required" }}
              {...(profile?.clientType !== "DS" && {
                value: warehouses?.warehouses?.find(
                  (e: any) => e?.id === warehouse,
                )?.location,
              })}
            />

            <NewSelectInput
              labelClass="w-full"
              name="supervisorId"
              label="Supervisor (Optional)"
              placeholder=""
              selectOptions={
                staffData?.map((supervisor: any) => ({
                  id: supervisor.id,
                  value: supervisor.id,
                  text: supervisor.name,
                })) || []
              }
              clearErrors={clearErrors}
              register={register}
              validation={{ required: false }}
              error={errors.supervisorId}
              disabled={!staffData || staffData.length === 0}
              value={watch("supervisorId")}
              setValue={(val: string) => {
                setSelectedSupervisor(val);
                setValue("supervisorId", val);
              }}
            />
            <NewinputField
              labelClass="w-full"
              name="startDate"
              type="date"
              title="Start Date"
              placeholder=""
              register={register}
              error={errors?.startDate}
              validation={{
                required: "Start date is required",
              }}
              disabled={!!driverData}
              min={new Date().toISOString().split("T")[0]}
            />
            <NewSelectInput
              labelClass="w-full"
              name="timeSlotId"
              label="Time Slot"
              selectOptions={
                timeSlotData?.map((t: any) => ({
                  id: t.id,
                  value: t.id,
                  text: t.slotName,
                })) || []
              }
              clearErrors={clearErrors}
              register={register}
              disabled={!data || data?.length === 0}
              value={watch("timeSlotId")}
              setValue={(val: string) => {
                setSelectedTimeSlot(val);
                setValue("timeSlotId", val);
              }}
            />
          </div>
        </div>

        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconTruck} title=" Vehicle Details" />
          <div className="grid grid-cols-2 gap-4">
            <NewSelectInput
              name="vehicleType"
              label="Vehicle Type (Optional)"
              labelClass="w-full"
              placeholder=""
              selectOptions={vehicleTypes}
              register={register}
              value={watch("vehicleType")?.toLowerCase()}
              setValue={(val: string) => {
                setValue("vehicleType", val);
              }}
            />

            <NewSelectInput
              name="vehicleId"
              label="Assign Vehicle (Optional)"
              labelClass="w-full"
              placeholder=""
              selectOptions={
                vehicles?.map((vehicle: any) => ({
                  id: vehicle.id,
                  value: vehicle.id,
                  text: vehicle?.name,
                })) || []
              }
              value={watch("vehicleId")}
              setValue={(val: string) => {
                setAssignVehicle(val);
                setValue("vehicleId", val);
              }}
              clearErrors={clearErrors}
              register={register}
            />
          </div>
        </div>
        <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
          <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
          <SectionHeader icon={IconId} title="Identification Documents" />
          <div className="grid grid-cols-2 gap-4">
            <div className="flex items-center gap-2 w-full">
              <NewinputField
                name="iqamaNumber"
                type="number"
                title="Iqama Number"
                className="w-full"
                placeholder=""
                register={register}
                error={errors?.iqamaNumber}
                validation={{
                  required: "Iqama number is required",
                  validate: (value: string) =>
                    value.trim().length === 10
                      ? true
                      : "Iqama number must be 10 digits",
                }}
                other={{
                  maxLength: 10,
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    let value = e.target.value.replace(/\D/g, "");
                    if (value.length > 10) {
                      value = value.slice(0, 10);
                    }
                    setValue("iqamaNumber", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />
              <div className="mt-6">
                <Controller
                  control={control}
                  name="iqamaDoc"
                  rules={{
                    required: "File is required",
                    validate: (file: File) => {
                      if (!file) return "Please select a file";

                      const MAX_SIZE = 1 * 1024 * 1024;
                      if (file?.size > MAX_SIZE) {
                        return "File size must be 1 MB or less";
                      }

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "application/pdf",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg", "pdf"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, PDF, or PNG allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => {
                    const fileName =
                      field.value instanceof File
                        ? field.value.name
                        : typeof field.value === "string" && field.value
                          ? decodeURIComponent(
                              field.value.split("/").pop() || "",
                            )
                          : "";

                    return (
                      <div>
                        <input
                          type="file"
                          id="iqama-doc"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) field.onChange(file);
                          }}
                        />
                        <label
                          htmlFor="iqama-doc"
                          className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                        >
                          <IconCloudUpload stroke={1} size={20} />
                        </label>
                        {fieldState.error ? (
                          <p className="text-red-500 text-xs leading-tight">
                            {fieldState.error.message}
                          </p>
                        ) : fileName ? (
                          <p
                            className="text-green-600 text-xs leading-tight truncate max-w-[100px]"
                            title={fileName}
                          >
                            <T>✓ Uploaded File</T>{" "}
                            {fileName.length > 12
                              ? `${fileName.slice(0, 12)}...`
                              : fileName}
                          </p>
                        ) : null}
                      </div>
                    );
                  }}
                />
              </div>
            </div>

            <div className="flex items-center gap-2  w-full">
              <NewinputField
                name="licenseNumber"
                className="w-full"
                type="text"
                title="License Number"
                placeholder="9874525410"
                register={register}
                error={errors?.licenseNumber}
                validation={{
                  required: "License number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "License number must be exactly 10 digits",
                  },
                }}
                other={{
                  maxLength: 10,
                  inputMode: "numeric",
                  onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                    const value = e.target.value
                      .replace(/\D/g, "")
                      .slice(0, 10);
                    setValue("licenseNumber", value, {
                      shouldValidate: true,
                      shouldDirty: true,
                    });
                  },
                }}
              />

              <div className="mt-6">
                <Controller
                  control={control}
                  name="licenseDoc"
                  rules={{
                    required: "File is required",
                    validate: (file: File) => {
                      if (!file) return "Please select a file";

                      const MAX_SIZE = 1 * 1024 * 1024;
                      if (file?.size > MAX_SIZE) {
                        return "File size must be 1 MB or less";
                      }

                      const allowedTypes = [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "application/pdf",
                      ];
                      if (
                        file.type
                          ? !allowedTypes.includes(file.type)
                          : !["jpeg", "png", "jpg", "pdf"].includes(
                              getFileExtension(file as any),
                            )
                      ) {
                        return "Only JPG, JPEG, PDF, or PNG allowed";
                      }
                      return true;
                    },
                  }}
                  render={({ field, fieldState }) => {
                    const fileName =
                      field.value instanceof File
                        ? field.value.name
                        : typeof field.value === "string" && field.value
                          ? decodeURIComponent(
                              field.value.split("/").pop() || "",
                            )
                          : "";

                    return (
                      <div>
                        <input
                          type="file"
                          id="license-doc"
                          className="hidden"
                          onChange={(e) => {
                            const file = e.target.files?.[0];
                            if (file) field.onChange(file);
                          }}
                        />
                        <label
                          htmlFor="license-doc"
                          className="flex items-center justify-center py-[7px] px-3 border border-[#D2D2D2] rounded-xl cursor-pointer bg-[#FBD037]/20"
                        >
                          <IconCloudUpload stroke={1} size={20} />
                        </label>
                        {fieldState.error ? (
                          <p className="text-red-500 text-xs leading-tight">
                            {fieldState.error.message}
                          </p>
                        ) : fileName ? (
                          <p
                            className="text-green-600 text-xs leading-tight truncate max-w-[100px]"
                            title={fileName}
                          >
                            <T>✓ Uploaded File</T>{" "}
                            {fileName.length > 12
                              ? `${fileName.slice(0, 12)}...`
                              : fileName}
                          </p>
                        ) : null}
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddDriverModal;
